import { render, staticRenderFns } from "./lebel.vue?vue&type=template&id=218c8c94"
import script from "./lebel.vue?vue&type=script&lang=js"
export * from "./lebel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports